'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconNamePropType = getIconNamePropType;

var _react = require('react');

var _iconNames = require('icons/iconNames');

var _iconNames2 = _interopRequireDefault(_iconNames);

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propType = void 0;

function getIconNamePropType() {
  if (!propType) {
    propType = _react.PropTypes.oneOf(_iconNames2.default);
  }

  return (0, _createChainablePropType2.default)(propType, 'iconName');
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/utils/propTypes/iconName.js
// module id = 41
// module chunks = 0